import React from "react";
import styled from "styled-components";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const StyleTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  align-items: flex-end;
  background: #0B0B0BCC;
  font-family: Platypi;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 700;
  line-height: 20.52px;
  text-align: left;
  padding-top: 8px;
  padding-bottom: 8px;
  @media ${({ theme }) => theme.devices.tablet} {
    font-size: 9px;
    align-items: flex-start;
    .hideAlert {
      display: none;
    }
  }
`;
const StyleOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1444px;
  width: 100%;
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 52px;
  padding-right: 52px;

  .header-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 32px;

    .header-logo-image {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .header-logo-title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .header-logo-text {
        font-family: Platypi;
        font-weight: 700;
        font-size: 36px;
        line-height: 41px;
        color: #000000;
      }

      .header-logo-subtext {
        font-family: Platypi;
        font-weight: 400;
        font-size: 24px;
        line-height: 27px;
        color: #000000;
      }
    }
  }

  .header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 24px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;

    .header-left {
      gap: 8px;

      .header-logo-image {
        img {
          height: 32px;
        }
      }

      .header-logo-title {
        .header-logo-text {
          font-size: 16px;
          line-height: 20px;
        }

        .header-logo-subtext {
          display: none;
        }
      }
    }

    .header-right {
      gap: 8px;

      .header-top-firm-badge {
        img {
          height: 40px;
        }
      }

      .header-e-file-badge {
        padding-left: 8px;
        padding-right: 8px;

        img {
          height: 40px;
        }
      }
    }
  }
`;
const StyledButton = styled.div`
  font-family: Platypi;
  font-size: 12px;
  font-weight: 700;
  line-height: 16.51px;
  text-align: left;
  color: #FFFFFF;
  background-color: #FF0000;
  border-radius: 5px ;
  padding: 3px 25px 6px 25px;
  cursor: pointer;
  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }
`;
function Header() {
  return (
    <React.Fragment>
      <StyleTopContainer>
        <div>
          <picture>
            <source srcSet={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-4/alert.svg`} type="image/png" />
            <img src={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-4/alert.svg`} alt="Logo" />
          </picture>
        </div>
        <div>PLEASE NOTE: 2023 Extensions are due <u>October 15th.</u></div>
        <a href="https://turbotax.intuit.com/personal-taxes/online/live/full-service/business-taxes/" target="_blank">
          <StyledButton>START FILING</StyledButton>
        </a>
        <div className="hideAlert">
          <picture>
            <source srcSet={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-4/alert.svg`} type="image/png" />
            <img src={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-4/alert.svg`} alt="Logo" />
          </picture>
        </div>
      </StyleTopContainer>
      <StyleOuterContainer>
        <StyledInnerContainer>
          <div className="header-left">
            <div className="header-logo-image">
              <picture>
                <source srcSet={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-4/logo.svg`} type="image/png" />
                <img src={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-4/logo.svg`} alt="Logo" />
              </picture>
            </div>
            <div className="header-logo-title">
              <div className="header-logo-text">US Tax Filing</div>
              <div className="header-logo-subtext">US Online Tax Prep & Document Filing</div>
            </div>
          </div>
        </StyledInnerContainer>
      </StyleOuterContainer>
    </React.Fragment>
  );
}

export default Header;
